import styled from 'styled-components';
import { PageHeader } from 'ui/pageHeader';
import { colors, spacing, fontSizes, body2 } from 'ui/theme';
import { InputText } from 'ui/inputs';
import { pxToRem } from 'utils/convert';

const appWidthConstraint = `
  margin-left: -${pxToRem(40)};
  margin-right: -${pxToRem(40)};
`;

export const StyledFullWidth = styled.div`
  ${appWidthConstraint};
`;

export const MainLayoutWrapper = styled(StyledFullWidth)`
  display: flex;
  justify-content: center;

  &[data-background-color='${colors.backgroundSecondary}'] {
    background: ${colors.backgroundSecondary};
  }
  &[data-background-color='${colors.white}'] {
    background: ${colors.white};
  }
`;

export const MainLayoutHeaderWrapper = styled(MainLayoutWrapper)`
  margin-top: -${pxToRem(20)};
`;

export const MainContentLayout = styled.div`
  width: 100%;
  max-width: ${pxToRem(1216)};
`;

export const AlignedPageHeader = styled(PageHeader)`
  align-items: center;
  margin-top: ${spacing.plusHalf};
  margin-bottom: 0;
`;

export const CreateOrEditActionFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing.base};
  border-top: 1px solid ${colors.borderPrimary};
  background-color: ${colors.backgroundPrimary};
  margin-left: -${spacing.double};
  margin-right: -${spacing.double};
`;

// Icon wrapper increases clickable area of the suffix
export const IconWrapper = styled.div`
  display: flex;
  height: ${pxToRem(22)};
  width: ${pxToRem(22)};
  align-items: center;
  justify-content: center;
`;

export const StyledInputText = styled(InputText)`
  background-color: ${colors.backgroundDisabled};
  border-color: ${colors.borderPrimary};

  input {
    background-color: transparent !important;
    text-overflow: ellipsis;
    font-family: monospace;
    font-size: ${fontSizes.s12};
  }
`;

export const CreateOrEditActionLayout = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: ${spacing.base} ${spacing.plusHalf};
  gap: ${spacing.half};
`;

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    > div {
      width: 50%;
    } 
`;

export const StyledPageHeader = styled(PageHeader)`
  padding: ${spacing.double};
  background-color: ${colors.backgroundSecondary};
  margin: -${pxToRem(19)} -${spacing.double} 0 -${spacing.double};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  > div {
    width: 100%;
  }
  `;

export const DescriptionContainer = styled.div`
  ${body2}
  padding-top: ${spacing.plusHalf};
  padding-bottom: ${spacing.plusHalf};
  color: ${colors.textSecondary};
`;

export const SpinnerContainer = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
